module.exports = __webpack_public_path__ + "images/application/templates/user-invite-ebb34d11.png";